<template>
  <v-dialog
    v-model="twoFaDialog"
    no-click-animation
    overlay-color="rgba(39, 50, 64)"
    overlay-opacity="0.6"
    persistent
    width="500"
    :transition="false"
  >
    <v-card class="pa-0">
      <v-card-title class="pl-5 pt-3">
        <span>
          {{ $t("security.activate") }}
        </span>
        <v-spacer />
        <v-btn icon @click="twoFaDialog = false">
          <icon-custom name="icn24_close" />
        </v-btn>
      </v-card-title>
      <v-stepper v-model="step" style="box-shadow: none" class="twoFaStepper">
        <v-stepper-header
          style="box-shadow: none; background-color: var(--surface-color-10)"
        >
          <template v-if="!$vuetify.breakpoint.sm && !$vuetify.breakpoint.xs">
            <v-stepper-step color="success" :complete="step > 1" step="1">
              <span>
                {{ $t("security.stepOne") }}
              </span>
            </v-stepper-step>

            <v-divider />

            <v-stepper-step color="success" :complete="step > 2" step="2">
              {{ $t("security.stepTwo") }}
            </v-stepper-step>

            <v-divider />

            <v-stepper-step color="success" step="3" :complete="success">
              {{ $t("security.stepThree") }}
            </v-stepper-step>
          </template>
          <template v-else>
            <v-stepper-step color="success" :step="step">
              <span class="ml-2">
                <b>{{ $t("security.step") }} {{ step }}</b>
                {{ $t("security.of") }} 3
              </span>
            </v-stepper-step>
          </template>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-card class="px-1 py-2">
              <v-select
                v-model.trim="method"
                outlined
                class="mt-0 mb-0"
                :items="methods"
                :item-text="'text'"
                :item-value="'id'"
                :item-disabled="'disabled'"
                name="method"
                :label="$t('security.chooseMethod')"
                required
              />
              <v-layout
                v-if="method == 'google2fa'"
                wrap
                mb-12
                pa-4
                class="twoFa__method"
              >
                <v-flex
                  xs12
                  md7
                  mb-4
                  d-flex
                  pa-1
                  column
                  flex-column
                  align-left
                  justify-center
                >
                  <span>
                    {{ $t("security.download") }}
                  </span>
                  <b>{{
                    method == "google2fa"
                      ? $t("security.google2fa")
                      : $t("security.telegram2fa")
                  }}</b>
                </v-flex>
                <v-flex d-flex flex-column md5 xs12 text-left align-end>
                  <div
                    class="mb-3"
                    @click="
                      downloadApp(
                        'https://apps.apple.com/us/app/google-authenticator/id388497605'
                      )
                    "
                  >
                    <svg
                      width="135"
                      height="40"
                      viewBox="0 0 135 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width="135" height="40" rx="10" fill="#0C0D10" />
                      <path
                        d="M81.5259 19.2009V21.4919H80.0899V22.9943H81.5259V28.0993C81.5259 29.8425 82.3145 30.5397 84.2984 30.5397C84.647 30.5397 84.9791 30.4982 85.2696 30.4484V28.9626C85.0206 28.9875 84.8628 29.0041 84.5889 29.0041C83.7007 29.0041 83.3106 28.589 83.3106 27.6428V22.9943H85.2696V21.4919H83.3106V19.2009H81.5259Z"
                        fill="white"
                      />
                      <path
                        d="M90.3234 30.6642C92.9631 30.6642 94.5817 28.8962 94.5817 25.966C94.5817 23.0524 92.9548 21.2761 90.3234 21.2761C87.6838 21.2761 86.0568 23.0524 86.0568 25.966C86.0568 28.8962 87.6755 30.6642 90.3234 30.6642ZM90.3234 29.0788C88.7712 29.0788 87.8996 27.9416 87.8996 25.966C87.8996 24.007 88.7712 22.8615 90.3234 22.8615C91.8674 22.8615 92.7473 24.007 92.7473 25.966C92.7473 27.9333 91.8674 29.0788 90.3234 29.0788Z"
                        fill="white"
                      />
                      <path
                        d="M95.9666 30.4899H97.7513V25.1525C97.7513 23.8825 98.7059 23.0275 100.059 23.0275C100.374 23.0275 100.906 23.0856 101.055 23.1354V21.3757C100.864 21.3259 100.524 21.301 100.258 21.301C99.0794 21.301 98.075 21.9484 97.8177 22.8366H97.6849V21.4504H95.9666V30.4899Z"
                        fill="white"
                      />
                      <path
                        d="M105.486 22.7951C106.806 22.7951 107.669 23.7165 107.711 25.1359H103.145C103.245 23.7248 104.166 22.7951 105.486 22.7951ZM107.703 28.0495C107.371 28.7551 106.632 29.1452 105.553 29.1452C104.125 29.1452 103.204 28.1408 103.145 26.5554V26.4557H109.529V25.8332C109.529 22.9943 108.01 21.2761 105.495 21.2761C102.946 21.2761 101.328 23.1105 101.328 25.9992C101.328 28.8879 102.913 30.6642 105.503 30.6642C107.57 30.6642 109.014 29.6681 109.421 28.0495H107.703Z"
                        fill="white"
                      />
                      <path
                        d="M69.8223 27.1518C69.96 29.3715 71.8098 30.791 74.5629 30.791C77.5053 30.791 79.3464 29.3026 79.3464 26.9281C79.3464 25.0611 78.2968 24.0287 75.7502 23.435L74.3822 23.0995C72.7647 22.7209 72.1109 22.2133 72.1109 21.3272C72.1109 20.2087 73.1261 19.4774 74.6489 19.4774C76.0943 19.4774 77.0923 20.1915 77.273 21.3358H79.1486C79.0367 19.2451 77.1956 17.7739 74.6747 17.7739C71.9646 17.7739 70.1579 19.2451 70.1579 21.4562C70.1579 23.2802 71.1817 24.3642 73.4272 24.889L75.0275 25.2762C76.6707 25.6634 77.3934 26.2312 77.3934 27.1776C77.3934 28.2788 76.2578 29.0789 74.7091 29.0789C73.0487 29.0789 71.8958 28.3304 71.7323 27.1518H69.8223Z"
                        fill="white"
                      />
                      <path
                        d="M51.335 21.301C50.1065 21.301 49.044 21.9152 48.4961 22.9445H48.3633V21.4504H46.6451V33.4948H48.4297V29.1203H48.5708C49.044 30.0749 50.065 30.6393 51.3516 30.6393C53.6343 30.6393 55.087 28.8381 55.087 25.966C55.087 23.0939 53.6343 21.301 51.335 21.301ZM50.8287 29.0373C49.3345 29.0373 48.3965 27.8586 48.3965 25.9743C48.3965 24.0817 49.3345 22.903 50.837 22.903C52.3477 22.903 53.2525 24.0568 53.2525 25.966C53.2525 27.8835 52.3477 29.0373 50.8287 29.0373Z"
                        fill="white"
                      />
                      <path
                        d="M61.3318 21.301C60.1033 21.301 59.0408 21.9152 58.4929 22.9445H58.3601V21.4504H56.6419V33.4948H58.4265V29.1203H58.5676C59.0408 30.0749 60.0618 30.6393 61.3484 30.6393C63.6311 30.6393 65.0838 28.8381 65.0838 25.966C65.0838 23.0939 63.6311 21.301 61.3318 21.301ZM60.8255 29.0373C59.3313 29.0373 58.3933 27.8586 58.3933 25.9743C58.3933 24.0817 59.3313 22.903 60.8338 22.903C62.3445 22.903 63.2493 24.0568 63.2493 25.966C63.2493 27.8835 62.3445 29.0373 60.8255 29.0373Z"
                        fill="white"
                      />
                      <path
                        d="M43.4431 30.4899H45.4907L41.0083 18.075H38.9348L34.4524 30.4899H36.4312L37.5755 27.1948H42.3074L43.4431 30.4899ZM39.8726 20.3292H40.0189L41.817 25.5773H38.0659L39.8726 20.3292Z"
                        fill="white"
                      />
                      <path
                        d="M35.6511 8.71094V14.7H37.8135C39.5981 14.7 40.6316 13.6001 40.6316 11.6868C40.6316 9.80249 39.5898 8.71094 37.8135 8.71094H35.6511ZM36.5808 9.55762H37.7097C38.9507 9.55762 39.6853 10.3462 39.6853 11.6992C39.6853 13.073 38.9631 13.8533 37.7097 13.8533H36.5808V9.55762Z"
                        fill="white"
                      />
                      <path
                        d="M43.7967 14.7871C45.1165 14.7871 45.9258 13.9031 45.9258 12.438C45.9258 10.9812 45.1124 10.093 43.7967 10.093C42.4769 10.093 41.6634 10.9812 41.6634 12.438C41.6634 13.9031 42.4727 14.7871 43.7967 14.7871ZM43.7967 13.9944C43.0206 13.9944 42.5848 13.4258 42.5848 12.438C42.5848 11.4585 43.0206 10.8857 43.7967 10.8857C44.5687 10.8857 45.0086 11.4585 45.0086 12.438C45.0086 13.4216 44.5687 13.9944 43.7967 13.9944Z"
                        fill="white"
                      />
                      <path
                        d="M52.818 10.1802H51.9256L51.1205 13.6292H51.0499L50.1202 10.1802H49.2652L48.3355 13.6292H48.2691L47.4598 10.1802H46.555L47.8001 14.7H48.7174L49.6471 11.3713H49.7176L50.6515 14.7H51.577L52.818 10.1802Z"
                        fill="white"
                      />
                      <path
                        d="M53.8456 14.7H54.7379V12.0562C54.7379 11.3506 55.1571 10.9106 55.817 10.9106C56.477 10.9106 56.7924 11.2717 56.7924 11.998V14.7H57.6847V11.7739C57.6847 10.699 57.1286 10.093 56.12 10.093C55.4394 10.093 54.9911 10.396 54.7711 10.8982H54.7047V10.1802H53.8456V14.7Z"
                        fill="white"
                      />
                      <path
                        d="M59.09 14.7H59.9824V8.41626H59.09V14.7Z"
                        fill="white"
                      />
                      <path
                        d="M63.3384 14.7871C64.6582 14.7871 65.4675 13.9031 65.4675 12.438C65.4675 10.9812 64.6541 10.093 63.3384 10.093C62.0186 10.093 61.2051 10.9812 61.2051 12.438C61.2051 13.9031 62.0144 14.7871 63.3384 14.7871ZM63.3384 13.9944C62.5623 13.9944 62.1265 13.4258 62.1265 12.438C62.1265 11.4585 62.5623 10.8857 63.3384 10.8857C64.1104 10.8857 64.5503 11.4585 64.5503 12.438C64.5503 13.4216 64.1104 13.9944 63.3384 13.9944Z"
                        fill="white"
                      />
                      <path
                        d="M68.1263 14.0234C67.6407 14.0234 67.2879 13.7869 67.2879 13.3801C67.2879 12.9817 67.5701 12.77 68.1927 12.7285L69.2967 12.658V13.0356C69.2967 13.5959 68.7986 14.0234 68.1263 14.0234ZM67.898 14.7747C68.4915 14.7747 68.9854 14.5173 69.2552 14.0649H69.3257V14.7H70.1849V11.6121C70.1849 10.6575 69.5457 10.093 68.4126 10.093C67.3875 10.093 66.657 10.5911 66.5657 11.3672H67.429C67.5286 11.0476 67.8731 10.865 68.3711 10.865C68.9812 10.865 69.2967 11.1348 69.2967 11.6121V12.0022L68.0723 12.0728C66.9974 12.1392 66.3914 12.6082 66.3914 13.4216C66.3914 14.2476 67.0264 14.7747 67.898 14.7747Z"
                        fill="white"
                      />
                      <path
                        d="M73.213 14.7747C73.8355 14.7747 74.3626 14.48 74.6324 13.9861H74.703V14.7H75.558V8.41626H74.6656V10.8982H74.5992C74.3543 10.4001 73.8314 10.1055 73.213 10.1055C72.0716 10.1055 71.337 11.0103 71.337 12.438C71.337 13.8699 72.0633 14.7747 73.213 14.7747ZM73.4662 10.9065C74.2132 10.9065 74.6822 11.5 74.6822 12.4421C74.6822 13.3884 74.2174 13.9736 73.4662 13.9736C72.7108 13.9736 72.2584 13.3967 72.2584 12.438C72.2584 11.4875 72.7149 10.9065 73.4662 10.9065Z"
                        fill="white"
                      />
                      <path
                        d="M81.3444 14.7871C82.6643 14.7871 83.4736 13.9031 83.4736 12.438C83.4736 10.9812 82.6601 10.093 81.3444 10.093C80.0246 10.093 79.2111 10.9812 79.2111 12.438C79.2111 13.9031 80.0205 14.7871 81.3444 14.7871ZM81.3444 13.9944C80.5683 13.9944 80.1325 13.4258 80.1325 12.438C80.1325 11.4585 80.5683 10.8857 81.3444 10.8857C82.1164 10.8857 82.5563 11.4585 82.5563 12.438C82.5563 13.4216 82.1164 13.9944 81.3444 13.9944Z"
                        fill="white"
                      />
                      <path
                        d="M84.6548 14.7H85.5471V12.0562C85.5471 11.3506 85.9663 10.9106 86.6262 10.9106C87.2861 10.9106 87.6016 11.2717 87.6016 11.998V14.7H88.4939V11.7739C88.4939 10.699 87.9377 10.093 86.9292 10.093C86.2485 10.093 85.8003 10.396 85.5803 10.8982H85.5139V10.1802H84.6548V14.7Z"
                        fill="white"
                      />
                      <path
                        d="M92.6036 9.05542V10.2009H91.8856V10.9521H92.6036V13.5046C92.6036 14.3762 92.9979 14.7249 93.9898 14.7249C94.1642 14.7249 94.3302 14.7041 94.4754 14.6792V13.9363C94.3509 13.9487 94.2721 13.957 94.1351 13.957C93.691 13.957 93.4959 13.7495 93.4959 13.2764V10.9521H94.4754V10.2009H93.4959V9.05542H92.6036Z"
                        fill="white"
                      />
                      <path
                        d="M95.6732 14.7H96.5656V12.0603C96.5656 11.3755 96.9723 10.9148 97.7028 10.9148C98.3336 10.9148 98.6698 11.28 98.6698 12.0022V14.7H99.5622V11.7822C99.5622 10.7073 98.9687 10.0972 98.0058 10.0972C97.3251 10.0972 96.8478 10.4001 96.6278 10.9065H96.5573V8.41626H95.6732V14.7Z"
                        fill="white"
                      />
                      <path
                        d="M102.781 10.8525C103.441 10.8525 103.873 11.3132 103.894 12.0229H101.611C101.661 11.3174 102.121 10.8525 102.781 10.8525ZM103.889 13.4797C103.723 13.8325 103.354 14.0276 102.814 14.0276C102.101 14.0276 101.64 13.5254 101.611 12.7327V12.6829H104.802V12.3716C104.802 10.9521 104.043 10.093 102.785 10.093C101.511 10.093 100.702 11.0103 100.702 12.4546C100.702 13.8989 101.495 14.7871 102.789 14.7871C103.823 14.7871 104.545 14.2891 104.748 13.4797H103.889Z"
                        fill="white"
                      />
                      <path
                        d="M24.769 20.3008C24.7907 18.6198 25.6934 17.0292 27.1256 16.1488C26.2221 14.8584 24.7088 14.0403 23.1344 13.9911C21.4552 13.8148 19.8272 14.9959 18.9715 14.9959C18.0992 14.9959 16.7817 14.0086 15.363 14.0378C13.5137 14.0975 11.7898 15.1489 10.8901 16.7656C8.95607 20.1141 10.3987 25.0351 12.2513 27.7417C13.1782 29.0671 14.2615 30.5475 15.6789 30.495C17.066 30.4375 17.584 29.6105 19.2583 29.6105C20.9171 29.6105 21.4031 30.495 22.8493 30.4616C24.3377 30.4375 25.2754 29.1304 26.1698 27.7925C26.8358 26.8481 27.3483 25.8044 27.6882 24.7C25.9391 23.9602 24.771 22.2 24.769 20.3008Z"
                        fill="white"
                      />
                      <path
                        d="M22.0373 12.2111C22.8489 11.2369 23.2487 9.98469 23.1518 8.72046C21.912 8.85068 20.7668 9.44324 19.9443 10.3801C19.14 11.2954 18.7214 12.5255 18.8006 13.7415C20.0408 13.7542 21.2601 13.1777 22.0373 12.2111Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div
                    @click="
                      downloadApp(
                        'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2'
                      )
                    "
                  >
                    <svg
                      width="135"
                      height="40"
                      viewBox="0 0 135 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width="135" height="40" rx="10" fill="black" />
                      <path
                        d="M68.136 21.7511C65.784 21.7511 63.867 23.5401 63.867 26.0041C63.867 28.4531 65.784 30.2571 68.136 30.2571C70.489 30.2571 72.406 28.4531 72.406 26.0041C72.405 23.5401 70.488 21.7511 68.136 21.7511ZM68.136 28.5831C66.847 28.5831 65.736 27.5201 65.736 26.0051C65.736 24.4741 66.848 23.4271 68.136 23.4271C69.425 23.4271 70.536 24.4741 70.536 26.0051C70.536 27.5191 69.425 28.5831 68.136 28.5831ZM58.822 21.7511C56.47 21.7511 54.553 23.5401 54.553 26.0041C54.553 28.4531 56.47 30.2571 58.822 30.2571C61.175 30.2571 63.092 28.4531 63.092 26.0041C63.092 23.5401 61.175 21.7511 58.822 21.7511ZM58.822 28.5831C57.533 28.5831 56.422 27.5201 56.422 26.0051C56.422 24.4741 57.534 23.4271 58.822 23.4271C60.111 23.4271 61.222 24.4741 61.222 26.0051C61.223 27.5191 60.111 28.5831 58.822 28.5831ZM47.744 23.0571V24.8611H52.062C51.933 25.8761 51.595 26.6171 51.079 27.1321C50.451 27.7601 49.468 28.4531 47.744 28.4531C45.086 28.4531 43.008 26.3101 43.008 23.6521C43.008 20.9941 45.086 18.8511 47.744 18.8511C49.178 18.8511 50.225 19.4151 50.998 20.1401L52.271 18.8671C51.191 17.8361 49.758 17.0471 47.744 17.0471C44.103 17.0471 41.042 20.0111 41.042 23.6521C41.042 27.2931 44.103 30.2571 47.744 30.2571C49.709 30.2571 51.192 29.6121 52.351 28.4041C53.543 27.2121 53.914 25.5361 53.914 24.1831C53.914 23.7651 53.882 23.3781 53.817 23.0561H47.744V23.0571ZM93.052 24.4581C92.698 23.5081 91.618 21.7511 89.411 21.7511C87.22 21.7511 85.399 23.4751 85.399 26.0041C85.399 28.3881 87.204 30.2571 89.62 30.2571C91.569 30.2571 92.697 29.0651 93.165 28.3721L91.715 27.4051C91.232 28.1141 90.571 28.5811 89.62 28.5811C88.67 28.5811 87.993 28.1461 87.558 27.2921L93.245 24.9401L93.052 24.4581ZM87.252 25.8761C87.204 24.2321 88.525 23.3951 89.476 23.3951C90.217 23.3951 90.845 23.7661 91.055 24.2971L87.252 25.8761ZM82.629 30.0001H84.497V17.4991H82.629V30.0001ZM79.567 22.7021H79.503C79.084 22.2021 78.278 21.7511 77.264 21.7511C75.137 21.7511 73.188 23.6201 73.188 26.0211C73.188 28.4051 75.137 30.2581 77.264 30.2581C78.279 30.2581 79.084 29.8071 79.503 29.2921H79.567V29.9041C79.567 31.5311 78.697 32.4011 77.296 32.4011C76.152 32.4011 75.443 31.5801 75.153 30.8871L73.526 31.5641C73.993 32.6911 75.233 34.0771 77.296 34.0771C79.487 34.0771 81.34 32.7881 81.34 29.6461V22.0101H79.568V22.7021H79.567ZM77.425 28.5831C76.136 28.5831 75.057 27.5031 75.057 26.0211C75.057 24.5221 76.136 23.4271 77.425 23.4271C78.697 23.4271 79.696 24.5221 79.696 26.0211C79.696 27.5031 78.697 28.5831 77.425 28.5831ZM101.806 17.4991H97.335V30.0001H99.2V25.2641H101.805C103.873 25.2641 105.907 23.7671 105.907 21.3821C105.907 18.9971 103.874 17.4991 101.806 17.4991ZM101.854 23.5241H99.2V19.2391H101.854C103.249 19.2391 104.041 20.3941 104.041 21.3821C104.041 22.3501 103.249 23.5241 101.854 23.5241ZM113.386 21.7291C112.035 21.7291 110.636 22.3241 110.057 23.6431L111.713 24.3341C112.067 23.6431 112.727 23.4171 113.418 23.4171C114.383 23.4171 115.364 23.9961 115.38 25.0251V25.1541C115.042 24.9611 114.318 24.6721 113.434 24.6721C111.649 24.6721 109.831 25.6531 109.831 27.4861C109.831 29.1591 111.295 30.2361 112.935 30.2361C114.189 30.2361 114.881 29.6731 115.315 29.0131H115.379V29.9781H117.181V25.1851C117.182 22.9671 115.524 21.7291 113.386 21.7291ZM113.16 28.5801C112.55 28.5801 111.697 28.2741 111.697 27.5181C111.697 26.5531 112.759 26.1831 113.676 26.1831C114.495 26.1831 114.882 26.3601 115.38 26.6011C115.235 27.7601 114.238 28.5801 113.16 28.5801ZM123.743 22.0021L121.604 27.4221H121.54L119.32 22.0021H117.31L120.639 29.5771L118.741 33.7911H120.687L125.818 22.0021H123.743ZM106.937 30.0001H108.802V17.4991H106.937V30.0001Z"
                        fill="white"
                      />
                      <path
                        d="M47.418 10.2429C47.418 11.0809 47.1701 11.7479 46.673 12.2459C46.109 12.8379 45.3731 13.1339 44.4691 13.1339C43.6031 13.1339 42.8661 12.8339 42.2611 12.2339C41.6551 11.6329 41.3521 10.8889 41.3521 10.0009C41.3521 9.11194 41.6551 8.36794 42.2611 7.76794C42.8661 7.16694 43.6031 6.86694 44.4691 6.86694C44.8991 6.86694 45.3101 6.95094 45.7001 7.11794C46.0911 7.28594 46.404 7.50894 46.6381 7.78794L46.111 8.31594C45.714 7.84094 45.167 7.60394 44.468 7.60394C43.836 7.60394 43.29 7.82594 42.829 8.26994C42.368 8.71394 42.1381 9.29094 42.1381 9.99994C42.1381 10.7089 42.368 11.2859 42.829 11.7299C43.29 12.1739 43.836 12.3959 44.468 12.3959C45.138 12.3959 45.6971 12.1729 46.1441 11.7259C46.4341 11.4349 46.602 11.0299 46.647 10.5109H44.468V9.78994H47.375C47.405 9.94694 47.418 10.0979 47.418 10.2429Z"
                        fill="white"
                      />
                      <path
                        d="M52.0281 7.737H49.2961V9.639H51.7601V10.36H49.2961V12.262H52.0281V13H48.5251V7H52.0281V7.737Z"
                        fill="white"
                      />
                      <path
                        d="M55.279 13H54.508V7.737H52.832V7H56.955V7.737H55.279V13Z"
                        fill="white"
                      />
                      <path d="M59.938 13V7H60.709V13H59.938Z" fill="white" />
                      <path
                        d="M64.1281 13H63.3572V7.737H61.6812V7H65.8042V7.737H64.1281V13Z"
                        fill="white"
                      />
                      <path
                        d="M73.6089 12.225C73.0189 12.831 72.2859 13.134 71.4089 13.134C70.5319 13.134 69.7989 12.831 69.2099 12.225C68.6199 11.619 68.3259 10.877 68.3259 9.99999C68.3259 9.12299 68.6199 8.38099 69.2099 7.77499C69.7989 7.16899 70.5319 6.86499 71.4089 6.86499C72.2809 6.86499 73.0129 7.16999 73.6049 7.77899C74.1969 8.38799 74.4929 9.12799 74.4929 9.99999C74.4929 10.877 74.1979 11.619 73.6089 12.225ZM69.7789 11.722C70.2229 12.172 70.7659 12.396 71.4089 12.396C72.0519 12.396 72.5959 12.171 73.0389 11.722C73.4829 11.272 73.7059 10.698 73.7059 9.99999C73.7059 9.30199 73.4829 8.72799 73.0389 8.27799C72.5959 7.82799 72.0519 7.60399 71.4089 7.60399C70.7659 7.60399 70.2229 7.82899 69.7789 8.27799C69.3359 8.72799 69.1129 9.30199 69.1129 9.99999C69.1129 10.698 69.3359 11.272 69.7789 11.722Z"
                        fill="white"
                      />
                      <path
                        d="M75.5749 13V7H76.513L79.429 11.667H79.4619L79.429 10.511V7H80.1999V13H79.3949L76.344 8.106H76.3109L76.344 9.262V13H75.5749Z"
                        fill="white"
                      />
                      <path
                        d="M47.418 10.2429C47.418 11.0809 47.1701 11.7479 46.673 12.2459C46.109 12.8379 45.3731 13.1339 44.4691 13.1339C43.6031 13.1339 42.8661 12.8339 42.2611 12.2339C41.6551 11.6329 41.3521 10.8889 41.3521 10.0009C41.3521 9.11194 41.6551 8.36794 42.2611 7.76794C42.8661 7.16694 43.6031 6.86694 44.4691 6.86694C44.8991 6.86694 45.3101 6.95094 45.7001 7.11794C46.0911 7.28594 46.404 7.50894 46.6381 7.78794L46.111 8.31594C45.714 7.84094 45.167 7.60394 44.468 7.60394C43.836 7.60394 43.29 7.82594 42.829 8.26994C42.368 8.71394 42.1381 9.29094 42.1381 9.99994C42.1381 10.7089 42.368 11.2859 42.829 11.7299C43.29 12.1739 43.836 12.3959 44.468 12.3959C45.138 12.3959 45.6971 12.1729 46.1441 11.7259C46.4341 11.4349 46.602 11.0299 46.647 10.5109H44.468V9.78994H47.375C47.405 9.94694 47.418 10.0979 47.418 10.2429Z"
                        stroke="white"
                        stroke-width="0.2"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M52.0281 7.737H49.2961V9.639H51.7601V10.36H49.2961V12.262H52.0281V13H48.5251V7H52.0281V7.737Z"
                        stroke="white"
                        stroke-width="0.2"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M55.279 13H54.508V7.737H52.832V7H56.955V7.737H55.279V13Z"
                        stroke="white"
                        stroke-width="0.2"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M59.938 13V7H60.709V13H59.938Z"
                        stroke="white"
                        stroke-width="0.2"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M64.1281 13H63.3572V7.737H61.6812V7H65.8042V7.737H64.1281V13Z"
                        stroke="white"
                        stroke-width="0.2"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M73.6089 12.225C73.0189 12.831 72.2859 13.134 71.4089 13.134C70.5319 13.134 69.7989 12.831 69.2099 12.225C68.6199 11.619 68.3259 10.877 68.3259 9.99999C68.3259 9.12299 68.6199 8.38099 69.2099 7.77499C69.7989 7.16899 70.5319 6.86499 71.4089 6.86499C72.2809 6.86499 73.0129 7.16999 73.6049 7.77899C74.1969 8.38799 74.4929 9.12799 74.4929 9.99999C74.4929 10.877 74.1979 11.619 73.6089 12.225ZM69.7789 11.722C70.2229 12.172 70.7659 12.396 71.4089 12.396C72.0519 12.396 72.5959 12.171 73.0389 11.722C73.4829 11.272 73.7059 10.698 73.7059 9.99999C73.7059 9.30199 73.4829 8.72799 73.0389 8.27799C72.5959 7.82799 72.0519 7.60399 71.4089 7.60399C70.7659 7.60399 70.2229 7.82899 69.7789 8.27799C69.3359 8.72799 69.1129 9.30199 69.1129 9.99999C69.1129 10.698 69.3359 11.272 69.7789 11.722Z"
                        stroke="white"
                        stroke-width="0.2"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M75.5749 13V7H76.513L79.429 11.667H79.4619L79.429 10.511V7H80.1999V13H79.3949L76.344 8.106H76.3109L76.344 9.262V13H75.5749Z"
                        stroke="white"
                        stroke-width="0.2"
                        stroke-miterlimit="10"
                      />
                      <g filter="url(#filter0_ii_5_5167)">
                        <path
                          d="M10.4359 7.53797C10.1449 7.84597 9.9729 8.32397 9.9729 8.94297V31.059C9.9729 31.679 10.1449 32.156 10.4359 32.464L10.5099 32.536L22.8989 20.147V20.001V19.855L10.5099 7.46497L10.4359 7.53797Z"
                          fill="url(#paint0_linear_5_5167)"
                        />
                        <path
                          d="M27.0279 24.278L22.8989 20.147V20.001V19.855L27.0289 15.725L27.1219 15.778L32.0149 18.558C33.4119 19.352 33.4119 20.651 32.0149 21.446L27.1219 24.226L27.0279 24.278Z"
                          fill="url(#paint1_linear_5_5167)"
                        />
                        <g filter="url(#filter1_i_5_5167)">
                          <path
                            d="M27.1218 24.225L22.8978 20.001L10.4358 32.464C10.8958 32.952 11.6568 33.012 12.5138 32.526L27.1218 24.225Z"
                            fill="url(#paint2_linear_5_5167)"
                          />
                        </g>
                        <path
                          d="M27.1218 15.7769L12.5138 7.47694C11.6568 6.98994 10.8958 7.05094 10.4358 7.53894L22.8988 20.0019L27.1218 15.7769Z"
                          fill="url(#paint3_linear_5_5167)"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_ii_5_5167"
                          x="9.9729"
                          y="7.14087"
                          width="23.0898"
                          height="25.7208"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="BackgroundImageFix"
                            result="shape"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="-0.15" />
                          <feComposite
                            in2="hardAlpha"
                            operator="arithmetic"
                            k2="-1"
                            k3="1"
                          />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="shape"
                            result="effect1_innerShadow_5_5167"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="0.15" />
                          <feComposite
                            in2="hardAlpha"
                            operator="arithmetic"
                            k2="-1"
                            k3="1"
                          />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="effect1_innerShadow_5_5167"
                            result="effect2_innerShadow_5_5167"
                          />
                        </filter>
                        <filter
                          id="filter1_i_5_5167"
                          x="10.4358"
                          y="20.001"
                          width="16.686"
                          height="12.8607"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="BackgroundImageFix"
                            result="shape"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="-0.15" />
                          <feComposite
                            in2="hardAlpha"
                            operator="arithmetic"
                            k2="-1"
                            k3="1"
                          />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="shape"
                            result="effect1_innerShadow_5_5167"
                          />
                        </filter>
                        <linearGradient
                          id="paint0_linear_5_5167"
                          x1="21.8007"
                          y1="8.70897"
                          x2="5.0187"
                          y2="25.491"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#00A0FF" />
                          <stop offset="0.0066" stop-color="#00A1FF" />
                          <stop offset="0.2601" stop-color="#00BEFF" />
                          <stop offset="0.5122" stop-color="#00D2FF" />
                          <stop offset="0.7604" stop-color="#00DFFF" />
                          <stop offset="1" stop-color="#00E3FF" />
                        </linearGradient>
                        <linearGradient
                          id="paint1_linear_5_5167"
                          x1="33.8334"
                          y1="20.001"
                          x2="9.63753"
                          y2="20.001"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#FFE000" />
                          <stop offset="0.4087" stop-color="#FFBD00" />
                          <stop offset="0.7754" stop-color="#FFA500" />
                          <stop offset="1" stop-color="#FF9C00" />
                        </linearGradient>
                        <linearGradient
                          id="paint2_linear_5_5167"
                          x1="24.8279"
                          y1="22.2949"
                          x2="2.06939"
                          y2="45.0534"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#FF3A44" />
                          <stop offset="1" stop-color="#C31162" />
                        </linearGradient>
                        <linearGradient
                          id="paint3_linear_5_5167"
                          x1="7.29719"
                          y1="0.176745"
                          x2="17.4595"
                          y2="10.339"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#32A071" />
                          <stop offset="0.0685" stop-color="#2DA771" />
                          <stop offset="0.4762" stop-color="#15CF74" />
                          <stop offset="0.8009" stop-color="#06E775" />
                          <stop offset="1" stop-color="#00F076" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                </v-flex>
              </v-layout>
              <v-card-actions class="pr-0 pb-0">
                <v-layout pa-0 ma-0 wrap>
                  <v-flex md6 px-2>
                    <v-btn
                      :loading="loading"
                      block
                      @click="twoFaDialog = false"
                    >
                      {{ $t("balance.cancel") }}
                    </v-btn>
                  </v-flex>
                  <v-flex md6 px-2>
                    <v-btn
                      class="primary"
                      :disabled="loading || method == null"
                      :loading="loading"
                      block
                      @click="activate()"
                    >
                      {{ $t("globals.continueButton") }}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-card v-if="google2faData" class="px-1 py-2">
              <center>
                <p>
                  <small>
                    {{ $t("security.scanCode") }}
                  </small>
                </p>

                <qrcode
                  class="mb-2"
                  :value="`otpauth://totp/${google2faData.name}:${google2faData.email}?secret=${google2faData.secret}&issuer=${google2faData.name}`"
                  :options="{ width: 150 }"
                />
                <p>
                  <small>
                    {{ $t("security.unabletoScan") }}
                    {{ $t("security.backupSecret") }}
                  </small>
                </p>
                <v-text-field
                  outlined
                  :value="google2faData.secret"
                  :label="$t('security.secret')"
                  name="secret"
                  class="centered-input mt-5 mb-5"
                  readonly
                  hide-details="auto"
                  @focus="$event.target.select()"
                >
                  <template #append>
                    <v-icon
                      v-clipboard:copy="google2faData.secret"
                      style="cursor: pointer"
                    >
                      mdi-content-copy
                    </v-icon>
                  </template>
                </v-text-field>
                <v-checkbox
                  v-model="backupChecked"
                  class="ml-4 mb-6"
                  color="primary"
                >
                  <template #label>
                    <small>
                      <b>{{ $t("security.confirmBackup") }}</b>
                    </small>
                  </template>
                </v-checkbox>
              </center>
              <v-card-actions class="pr-0 pb-0">
                <v-layout pa-0 ma-0 wrap>
                  <v-flex md6 px-2>
                    <v-btn
                      :disabled="loading"
                      block
                      class="twoFa__backButton"
                      @click="step = 1"
                    >
                      {{ $t("security.backButton") }}
                    </v-btn>
                  </v-flex>
                  <v-flex md6 px-2>
                    <v-btn
                      class="primary"
                      :disabled="loading || !backupChecked"
                      :loading="loading"
                      block
                      @click="step = 3"
                    >
                      {{ $t("globals.continueButton") }}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-card v-if="!success" class="code px-1 py-2">
              <email-verification-code ref="emailcode" method="enable_twofa" />
              <p>
                <small>
                  <b> {{ $t("security.googleCode") }} </b><br />
                  <span>
                    {{ $t("security.googleCodeDesc") }}
                  </span>
                </small>
              </p>

              <v-text-field
                v-model.trim="verification_code"
                v-mask="'######'"
                outlined
                name="code"
                :error-messages="CodeErrors"
                @input="$v.verification_code.$touch()"
                @blur="$v.verification_code.$touch()"
              />

              <v-card-actions class="pr-0 pb-0">
                <v-layout pa-0 ma-0 wrap>
                  <v-flex md6 px-2>
                    <v-btn
                      primary
                      :disabled="loading"
                      block
                      class="twoFa__backButton"
                      @click="step = 2"
                    >
                      {{ $t("security.backButton") }}
                    </v-btn>
                  </v-flex>
                  <v-flex md6 px-2>
                    <v-btn
                      class="primary"
                      :disabled="loading || method == null"
                      :loading="loading"
                      block
                      @click="confirm()"
                    >
                      {{ $t("resetpassword.submit") }}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
            <v-card v-else>
              <v-card-text class="mt-5 mb-5 text-center">
                <helper-success-animation class="mb-4" />
                {{ successMessage }}
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn text @click="twoFaDialog = false">
                  {{ $t("globals.closeButton") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
  </v-dialog>
</template>

<script>
import EmailVerificationCode from "@/components/core/Security/partial/EmailVerificationCode.vue";
import GENERATE_SECRET from "@/graphql/mutations/GenerateTwoFaSecret.gql";
import ACTIVATE_TWOFA from "@/graphql/mutations/ActivateTwoFa.gql";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import { validationMixin } from "vuelidate";
import { mask } from "vue-the-mask";
import {
  required,
  numeric,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import IconCustom from "@/components/helper/IconCustom";

export default {
  name: "TwoFaDialog",
  directives: {
    mask,
  },
  components: {
    IconCustom,
    qrcode: VueQrcode,
    EmailVerificationCode,
  },
  mixins: [validationMixin],
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      success: false,
      successMessage: null,
      backupChecked: false,
      step: 1,
      verification_code: null,
      showCode: false,
      google2faData: null,
      method: null,
      copied: false,
      methods: [
        {
          id: "google2fa",
          text: this.$t("security.google2fa"),
          disabled: false,
        },
      ],
    };
  },
  validations() {
    return {
      verification_code: {
        required,
        numeric,
        minLength: minLength(6),
        maxLength: maxLength(6),
      },
    };
  },
  computed: {
    twoFaDialog: {
      get() {
        return this.showDialog;
      },
      set(val) {
        this.$emit("closeTwoFaDialog", val);
      },
    },
    CodeErrors() {
      const errors = [];
      if (!this.$v.verification_code.$dirty) return errors;
      !this.$v.verification_code.required &&
        errors.push(this.$t("profile.reqField"));
      (!this.$v.verification_code.numeric ||
        !this.$v.verification_code.minLength ||
        !this.$v.verification_code.maxLength) &&
        errors.push(this.$t("profile.supportCodeError"));
      return errors;
    },
  },
  methods: {
    downloadApp(url) {
      window.open(url, "_blank");
    },
    activate() {
      if (!this.method) return;
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: GENERATE_SECRET,
          variables: {
            method: this.method,
          },
        })
        .then((data) => {
          this.loading = false;
          this.step = 2;
          this.google2faData = data.data.generateTwoFaSecret;
        })
        .catch((error) => {
          this.errorHandler(error);
          this.loading = false;
        });
    },
    confirm() {
      this.$v.$touch();
      this.$v.$touch();
      this.$refs.emailcode.$v.$touch();
      if (this.$v.$invalid || this.$refs.emailcode.$v.$invalid) return;
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: ACTIVATE_TWOFA,
          variables: {
            method: this.method,
            email_verification_code: this.$refs.emailcode.verification_code,
            twofa_verification_code: this.verification_code,
          },
        })
        .then((data) => {
          this.loading = false;
          this.success = true;
          this.successMessage = data.data.activateTwoFa.message;
        })
        .catch((error) => {
          this.errorHandler(error);
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.download-app {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 10px 20px;
  max-width: 210px;
  cursor: pointer;
}
.twoFaStepper {
  .v-stepper__header {
    .v-stepper__step {
      &__step {
        width: 32px;
        height: 32px;
        &:before {
          content: "0";
        }
        &.success {
          background-color: var(--primary-color) !important;
          color: white !important;
        }
      }
      &--complete,
      &--active {
        .v-stepper__step__step {
          background-color: var(--primary-color) !important;
          color: white !important;
          .v-icon {
            color: white !important;
          }
        }
      }
      &--complete {
        .v-stepper__step__step:before {
          content: "";
        }
      }
    }
  }
  .v-stepper__label {
    font-size: 13px;
    padding-right: 16px;
    display: block !important;
  }
  .v-divider {
    margin: 0 0 0 -16px;
  }
  .v-input--checkbox {
    .v-label {
      font-weight: 400 !important;
      font-size: 11px;
      color: var(--surface-color) !important;
    }
  }
}
.twoFa {
  &__method {
    border: 2px dashed var(--surface-color-10);
    border-radius: 15px;
    font-size: 13px;
  }
  &__backButton {
    text-transform: capitalize !important;
  }
}
</style>
